"use strict";
var TransformMetadata = (function () {
    function TransformMetadata(target, propertyName, transformFn, options) {
        this.target = target;
        this.propertyName = propertyName;
        this.transformFn = transformFn;
        this.options = options;
    }
    return TransformMetadata;
}());
exports.TransformMetadata = TransformMetadata;

//# sourceMappingURL=TransformMetadata.js.map



//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/metadata/TransformMetadata.js
// module id = 1454
// module chunks = 3